import apiService from './apiService'
import {
  UI_FOCUSED_TYPE_BRAND,
  UI_FOCUSED_TYPE_CATEGORY,
  UI_FOCUSED_TYPE_PAGE, UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN,
} from '../../../pages/dynamicUi/constants'
import { getCategory, searchCategory } from './categoryService'
import { getBrand } from './brandService'
import { getDynamicPage } from './pageService'
import { getProductCampaign } from './focusItemService'


const getDynamicSearch = (query, type = UI_FOCUSED_TYPE_BRAND, normalCampaignsOnly = false) => {
  return type === UI_FOCUSED_TYPE_PAGE ? searchPages(query)
    : type === UI_FOCUSED_TYPE_CATEGORY ? searchCategory(query)
      : type === UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN ? searchProductCampaigns(query, normalCampaignsOnly)
        : requestBrandSearch(query)
}

const getInfoFor = (id, type = UI_FOCUSED_TYPE_BRAND) => {
  return type === UI_FOCUSED_TYPE_PAGE ? getDynamicPage(id)
    : type === UI_FOCUSED_TYPE_CATEGORY ? getCategory(id)
      : type === UI_FOCUSED_TYPE_PRODUCT_CAMPAIGN ? getProductCampaign(id)
        : getBrand(id)
}

const requestBrandSearch = (query) => {
  return apiService.get(URIS.product_brands, { params: { search: query } })
}

const searchPages = (query) => {
  return apiService.get(URIS.pages, { params: { search: query } })
}

const searchProductCampaigns = (query, normalOnly) => {
  return apiService.get(URIS.product_campaigns,
    { params:
        {
          search: query,
          ...(normalOnly && {type: 'normal'})
        }
    })
}

const requestProductSearch = (query, hasVariant = true) => {
  let queryParams = {
    variant: hasVariant,
    brief_search: true,
    search: query,
  }
  return apiService.get(URIS.products, { params: queryParams })
}

const requestCampaignSearch = (query) => {
  return apiService.get(URIS.campaign_brands, { params: { search: query } })
}

const requestUserSearch = (mobile) => {
  return apiService.get(URIS.users, { params: { mobile: mobile } })
}

const requestFlashSale = () => {
  return apiService.get(URIS.brandWeek)
}

const URIS_D = (url, param1) => {
  return {
    userSearch: `/v1/admin/user-search?mobile=${param1}`,
  }[url]
}

const URIS = {
  brandWeek: '/v1/product-brands/banners',
  categories: '/v1/categories',
  products: '/v1/products',
  product_brands: '/v1/products/brands',
  campaign_brands: '/v1/campaign-brands',
  product_campaigns: '/v1/products/product-campaigns',
  users: '/v1/admin/user-search',
  pages: '/v1/pages',
}

export {
  requestBrandSearch,
  requestProductSearch,
  searchPages,
  searchProductCampaigns,
  getDynamicSearch,
  requestCampaignSearch,
  requestFlashSale,
  requestUserSearch,
  getInfoFor
}
